import React, { useEffect, useState } from 'react';
import Badge from '@mui/material/Badge';
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import headerNotificationIcon from '../../../assets/headerNotificationIcon.svg';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  deleeNotificationRes,
  deleteNotificationReq,
  notificationReq,
  notificationResProps,
  UpdateNotificationStatusReq,
  UpdateNotificationStatusRes,
} from '@/views/HR/Notifications/types';
import {
  deleteNotificaion,
  getNotificaionList,
  updateNotiicationStatus,
} from '@/views/HR/Notifications/queries';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  Avatar,
  Grid,
  List,
  Menu,
  Typography,
  Box,
  Paper,
  Button,
  ListItem,
  alpha,
} from '@mui/material';
import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import TRANSREQ from '@/assets/TRANSREQ.png';
import Announcement from '@/assets/Announcement.png';
import Attendance from '@/assets/Attendance.png';
import birthDayNotification from '@/assets/birthDayNotification.png';
import DocumentExpiry from '@/assets/DocumentExpiry.png';
import employeePunch from '@/assets/employeePunch.png';
import leaveApplication from '@/assets/leaveApplication.png';
import leaveEXTN from '@/assets/leaveEXTN.png';
import leaveRejoin from '@/assets/leaveRejoin.png';
import loan from '@/assets/loan.png';
import login from '@/assets/login.png';
import meeting from '@/assets/meeting.png';
import timesheet from '@/assets/timesheet.png';
import transit from '@/assets/transit.png';
import wishes from '@/assets/wishes.png';
import { designTokens } from '@design-system';
import { useNavigate } from 'react-router-dom';

const primaryColor = designTokens.colors.primary[500];

const NotificationBell: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loggedUserData } = useAppSelector((state) => state.loginReducer);
  const [notificationAnchorEl, setNotificationAnchorEl] =
    useState<null | HTMLElement>(null);
  const [notifications, setNotifications] = useState<notificationResProps[]>(
    []
  );
  // const [_count, setCount] = useState<number>(0);
  const [unreadCount, setUnreadCount] = useState<number>(0);

  const [expandedTxnType, setExpandedTxnType] = useState<string | null>(null);
  const logged_empCode = loggedUserData?.emp_code;
  useEffect(() => {
    const payload: notificationReq = {
      emp_code: logged_empCode?.toString(),
      not_type: '',
    };
    initiateGetSNotificationList(payload);
  }, []);

  const handleNotificationClick = async (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const { mutate: initiateGetSNotificationList } = useMutation<
    AxiosResponse<any>,
    Error,
    notificationReq
  >({
    mutationKey: ['getNotificationList'],
    mutationFn: getNotificaionList,
    onSuccess(resp: any) {
      if (resp.data.status === false) {
        setNotifications([]);
        // setCount(0);
      } else {
        setNotifications(resp.data.result);
        // const unreadCount = resp.data.result.filter(
        //   (n: notificationResProps) => n.HRNOT_STATUS === "Unread"
        // ).length;
        // setCount(unreadCount);
      }
    },
  });

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const { mutate: ModifyNotificationStatus } = useMutation<
    AxiosResponse<UpdateNotificationStatusRes>,
    Error,
    UpdateNotificationStatusReq
  >({
    mutationKey: ['updateNotificationStatus'],
    mutationFn: updateNotiicationStatus,
    onSuccess(resp: any) {
      if (resp.data.status === false) {
        dispatch({
          type: 'OPEN_SNACK_TOAST',
          payload: {
            title: 'Error',
            message: 'Failed',
          },
        });
      } else {
        setNotifications((prevNotifications) => {
          const updatedNotifications = prevNotifications.map((notification) =>
            notification.HRNOTU_ID === resp.data.not_user_id
              ? { ...notification, HRNOT_STATUS: 'Read' }
              : notification
          );

          // const unreadCount = updatedNotifications.filter(
          //   (notification) => notification.HRNOT_STATUS === 'Unread'
          // ).length;

          // setCount(unreadCount);

          return updatedNotifications;
        });
      }
    },
  });

  const { mutate: deleteNotification } = useMutation<
    AxiosResponse<deleeNotificationRes>,
    Error,
    deleteNotificationReq
  >({
    mutationKey: ['removeNotification'],
    mutationFn: deleteNotificaion,
    onSuccess(resp: any) {
      if (resp.data.status === false) {
        dispatch({
          type: 'OPEN_SNACK_TOAST',
          payload: {
            title: 'Error',
            message: 'Failed',
          },
        });
      }
    },
  });

  const handleNotificationStatusChange = (
    not_user_id: string,
    status: string
  ) => {
    const payload = {
      emp_code: logged_empCode || '',
      flag: status,
      not_user_id: not_user_id,
    };

    ModifyNotificationStatus(payload);

    if (status === 'DELETE') {
      setNotifications((prevNotifications) => {
        const notificationToDelete = prevNotifications.find(
          (notification) => notification.HRNOTU_ID.toString() === not_user_id
        );

        if (notificationToDelete?.HRNOT_STATUS === 'Unread') {
          setUnreadCount((prevUnreadCount) => prevUnreadCount - 1);
        }

        return prevNotifications.filter(
          (notification) => notification.HRNOTU_ID.toString() !== not_user_id
        );
      });
    } else {
      setNotifications((prevNotifications) =>
        prevNotifications.map((notification) => {
          if (notification.HRNOTU_ID.toString() === not_user_id) {
            if (notification.HRNOT_STATUS === 'Unread') {
              setUnreadCount((prevUnreadCount) => prevUnreadCount - 1);
            }

            //----------Redirection---------------------------------------
            // If logged user matches notification's NOTE_TO, navigate to /applyLeave
            if (logged_empCode === notification.NOTE_TO) {
              // Assuming you're using a navigation function like `navigate`
              if (notification.HRNOT_TXN_TYPE === 'TIMESHEET') {
                navigate('/my-account', {
                  state: {
                    employeeID: logged_empCode,
                    defaultTab: 2,
                    defaultSubTab: 2,
                  }, // Assuming Attendance tab index is 4
                });

                setNotificationAnchorEl(null);
              } else if (notification.HRNOT_TXN_TYPE === 'ATTENDANCE') {
                navigate('/my-account', {
                  state: { employeeID: logged_empCode, defaultTab: 4 },
                });
                setNotificationAnchorEl(null);
              } else if (notification.HRNOT_TXN_TYPE === 'LEAV-APPN') {
                //navigate(`/ApplyLeave`);
                navigate('/my-account', {
                  state: {
                    employeeID: logged_empCode,
                    defaultTab: 2,
                    defaultSubTab: 1,
                  },
                });
                setNotificationAnchorEl(null);
              }
            } else {
              if (notification.HRNOT_TXN_CODE != null) {
                // setNotificationAnchorEl(null);
                // every approval notification opens My Approvals on that document type
                if (['HR', 'ASSET', 'FIN', 'OP'].includes(notification.HRNOT_MODULE ?? '')) {
                  navigate(
                    `/approvals/inbox?module=${notification.HRNOT_MODULE}&txn=${encodeURIComponent(notification.HRNOT_TXN_CODE)}`
                  );
                  setNotificationAnchorEl(null);
                }
              }
            }
            //----------Redirection End---------------------------------------

            return { ...notification, HRNOT_STATUS: 'Read' };
          }
          return notification;
        })
      );
    }
  };

  const handleDeleteAllNotifications = () => {
    const payload = {
      emp_code: logged_empCode || '',
      not_txn_type: 'ALL',
    };

    deleteNotification(payload);
    setNotifications([]);
    setUnreadCount(0);
  };

  const groupedNotifications = notifications.reduce(
    (groups, notification) => {
      const txnType = notification.HRNOT_TXN_TYPE || 'Others';
      if (!groups[txnType]) {
        groups[txnType] = [];
      }
      groups[txnType].push(notification);
      return groups;
    },
    {} as Record<string, notificationResProps[]>
  );

  const handleToggleExpand = (txnType: string) => {
    setExpandedTxnType(expandedTxnType === txnType ? null : txnType);
  };

  const getNotificationImage = (type: string) => {
    switch (type) {
      case 'TRANS_REQ':
        return TRANSREQ;
      case 'WISHES':
        return wishes;
      case 'ANNOUNCEMENT':
        return Announcement;
      case 'ATTENDANCE':
        return Attendance;
      case 'BDAY':
        return birthDayNotification;
      case 'DOC_EXP':
        return DocumentExpiry;
      case 'EMP-PUNCH':
        return employeePunch;
      case 'LEAV-APPN':
        return leaveApplication;
      case 'LEAV-EXTN':
        return leaveEXTN;
      case 'LEAV-RJOIN':
        return leaveRejoin;
      case 'LOAN-APPN':
        return loan;
      case 'LOGIN':
        return login;
      case 'MEETING':
        return meeting;
      case 'TIMESHEET':
        return timesheet;
      case 'TRANSIT':
        return transit;
      default:
        return Announcement;
    }
  };

  useEffect(() => {
    const newUnreadCount = notifications.filter(
      (notification) => notification.HRNOT_STATUS === 'Unread'
    ).length;
    setUnreadCount(newUnreadCount);
  }, [notifications]);

  function formatString(input: string): string {
    return input
      .toLowerCase()
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('-');
  }
  return (
    <>
      <IconButton
        onClick={handleNotificationClick}
        sx={{ ml: { lg: 2, xs: 0 } }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          anchorOrigin={{
            vertical: 'top', // Position the badge below the icon
            horizontal: 'right', // Position the badge to the right of the icon
          }}
          sx={{
            '& .MuiBadge-badge': {
              transform: 'translate(58%, -5%)', // Adjust the badge position further
            },
          }}
        >
          <img
            src={headerNotificationIcon}
            alt="Notification Icon"
            style={{
              width: '30px',
              height: '30px',
              filter: 'brightness(0) invert(1)',
            }}
          />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={notificationAnchorEl}
        open={Boolean(notificationAnchorEl)}
        onClose={handleNotificationClose}
        sx={{ marginTop: { xs: '8px', md: '34px' } }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            width: { xs: 'calc(100vw - 24px)', sm: '480px', md: '530px' },
            maxWidth: '95vw',
            maxHeight: 'calc(100vh - 100px)',
            borderRadius: '8px',
            marginTop: '8px',
            overflow: 'hidden',
          },
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            backgroundColor: (theme) => theme.palette.primary.main,
            color: 'white',
            zIndex: 10,
          }}
          // style={{ borderRadius: "8px" }}
        >
          <Grid item xs={6} sm={5}>
            <Typography
              variant="h6"
              style={{
                padding: '10px',
                textAlign: 'left',

                marginLeft: '20px',
              }}
            >
              Notifications
            </Typography>
          </Grid>

          <Grid
            item
            xs={6}
            sm={7}
            sx={{
              textAlign: 'right',
              color: 'white',
              mt: '5px',
              paddingRight: '32px',
            }}
          >
            <Button
              onClick={handleDeleteAllNotifications}
              size="large"
              sx={{
                color: 'white',
                textTransform: 'none',
              }}
            >
              Clear all
            </Button>
          </Grid>
        </Grid>
        <List
          sx={{
            maxHeight: 'calc(100vh - 180px)',
            overflowY: 'auto',
            paddingBottom: '16px',
            paddingTop: '16px',
            '&::-webkit-scrollbar': {
              width: '6px', // Custom scroll bar width
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888', // Scroll bar thumb color
              borderRadius: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1', // Scroll bar track color
            },
            'scrollbar-width': 'thin', // For Firefox
            'scrollbar-color': '#888 #f1f1f1', // Thumb color and track color for Firefox
          }}
        >
          {Object.keys(groupedNotifications).length === 0 ? (
            <List>
              <ListItem sx={{ justifyContent: 'center', width: '100%', py: 4 }}>
                <Typography
                  sx={{
                    color: '#94a3b8',
                    fontWeight: 500,
                    textAlign: 'center',
                    fontFamily: 'inherit',
                    fontSize: '0.875rem',
                  }}
                  variant="body1"
                >
                  No Notifications
                </Typography>
              </ListItem>
            </List>
          ) : (
            <List>
              {Object.entries(groupedNotifications).map(
                ([txnType, notifications], idx) => (
                  <div key={idx}>
                    <Box sx={{ paddingLeft: 3, paddingRight: 3 }}>
                      <Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: 1,
                            flexDirection: { xs: 'column', sm: 'row' },
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar
                              sx={{
                                bgcolor: alpha(primaryColor, 0.15),
                                marginRight: 1,
                                width: { xs: 28, sm: 36 },
                                height: { xs: 28, sm: 36 },
                              }}
                            >
                              <img
                                src={getNotificationImage(txnType)}
                                alt={txnType}
                                style={{
                                  width: '70%',
                                  height: '70%',
                                }}
                              />
                            </Avatar>

                            <Typography
                              sx={{
                                fontFamily: 'inherit',
                                fontWeight: 600,
                                marginRight: 1.5,
                                fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                                color: '#1e293b',
                              }}
                            >
                              {formatString(txnType)}
                            </Typography>

                            <Box
                              sx={{
                                bgcolor: primaryColor,
                                color: '#fff',
                                width: { xs: 22, sm: 26 },
                                height: { xs: 22, sm: 26 },
                                borderRadius: '8px',
                                fontSize:
                                  notifications.length > 99 ? '10px' : '12px',
                                fontWeight: 600,
                                fontFamily: 'inherit',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              {notifications.length}
                            </Box>
                          </Box>

                          {notifications.length > 1 && (
                            <Button
                              size="small"
                              sx={{
                                color: primaryColor,
                                textTransform: 'none',
                                marginTop: { xs: '10px', sm: 0 },
                                fontFamily: 'inherit',
                                fontWeight: 600,
                                fontSize: '0.8125rem',
                              }}
                              onClick={() => handleToggleExpand(txnType)}
                            >
                              {expandedTxnType === txnType
                                ? 'View Less'
                                : 'View All'}
                            </Button>
                          )}
                        </Box>

                        <Grid container spacing={2}>
                          {(expandedTxnType === txnType
                            ? notifications
                            : [notifications[0]]
                          ).map((notification, index) => (
                            <Grid item xs={12} key={index}>
                              <Box sx={{ position: 'relative' }}>
                                <Paper
                                  elevation={0}
                                  sx={{
                                    padding: 2,
                                    backgroundColor: '#fff',
                                    borderRadius: '10px',
                                    border: '1px solid #e2e8f0',
                                    cursor: 'pointer',
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                    transition: 'all 0.2s ease',
                                    borderLeft:
                                      notification.HRNOT_STATUS === 'Unread'
                                        ? `3px solid ${primaryColor}`
                                        : '3px solid transparent',
                                    '&:hover': {
                                      borderColor: primaryColor,
                                      boxShadow: `0 4px 12px ${alpha(primaryColor, 0.1)}`,
                                    },
                                  }}
                                  onClick={() =>
                                    handleNotificationStatusChange(
                                      notification.HRNOTU_ID.toString(),
                                      'UPDATE_READ'
                                    )
                                  }
                                >
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleNotificationStatusChange(
                                        notification.HRNOTU_ID.toString(),
                                        'DELETE'
                                      );
                                    }}
                                    sx={{
                                      position: 'absolute',
                                      top: 4,
                                      right: 4,
                                      backgroundColor: '#f1f5f9',
                                      width: 24,
                                      height: 24,
                                      borderRadius: '6px',
                                      '&:hover': {
                                        backgroundColor: '#e2e8f0',
                                      },
                                    }}
                                  >
                                    <CloseIcon
                                      sx={{
                                        fontSize: '0.875rem',
                                        color: '#64748b',
                                      }}
                                    />
                                  </IconButton>

                                  <Typography
                                    variant="body1"
                                    sx={{
                                      marginBottom: 0.5,
                                      fontSize: '0.8125rem',
                                      lineHeight: 1.5,
                                      color:
                                        notification.HRNOT_STATUS === 'Unread'
                                          ? '#1e293b'
                                          : '#64748b',
                                      fontWeight:
                                        notification.HRNOT_STATUS === 'Unread'
                                          ? 600
                                          : 400,
                                      fontFamily: 'inherit',
                                      pr: 3,
                                    }}
                                  >
                                    {notification.DESCRIPTION}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: '0.6875rem',
                                      color: '#94a3b8',
                                      fontFamily: 'inherit',
                                    }}
                                  >
                                    {notification.HRNOT_CR_DT}
                                  </Typography>
                                </Paper>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                    {idx < Object.entries(groupedNotifications).length - 1 && (
                      <hr
                        style={{
                          width: '100%',
                          borderColor: '#EBEEEF',
                          margin: '16px 0',
                          borderWidth: '0.5px',
                        }}
                      />
                    )}
                  </div>
                )
              )}
            </List>
          )}
        </List>
      </Menu>
    </>
  );
};

export default NotificationBell;
